/* 年月日 */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import DatePickerJp from '../organisms/DatePickerJp';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  value: Date | null;
  message?: string;
  name?: string;
  placeholder?: string;
  help_msg?: string;
  disabled: boolean;
  handleChange?: (date: Date) => void;
  handleBlur?: VoidFunction;
  handleCalendarClose?: VoidFunction;
  min_date?: Date | null;
  max_date?: Date | null;
}

const RowDate: React.FC<Props> = ({
  id,
  label,
  need,
  value,
  message,
  name,
  placeholder,
  help_msg,
  disabled,
  handleChange,
  handleBlur,
  handleCalendarClose,
  min_date,
  max_date,
}) => {
  const returnStringDateJp = () => {
    if (value !== null && typeof value !== 'undefined') {
      const year = value.getFullYear();
      const month = value.getMonth() + 1;
      const date = value.getDate();
      return `${year}年${month}月${date}日`;
    }
    return '';
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        disabled ? (
          <Paragraph label={returnStringDateJp()} />
        ) : (
          <>
            <DatePickerJp
              id={id}
              className="form-control"
              placeholder={placeholder}
              name={name}
              handleChangeDate={handleChange}
              selected={value}
              disabled={disabled}
              handleBlur={handleBlur}
              handleCalendarClose={handleCalendarClose}
              min_date={min_date}
              max_date={max_date}
            />
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default RowDate;
